import { Button, Card, Typography } from "antd";
import { ChevronDown } from "assets/svg";
import Pagination from "components/Pagination";
import { getLocalPaginatedList, getTotalPages } from "components/Pagination/helpers";
import Table from "components/Table";
import { sortLocalList } from "components/Table/helpers";
import { HeaderConfig, SortObject } from "components/Table/types";
import { I18nContext } from "contexts/I18n/I18nProvider";
import NoRecordsComponent from 'core/no-records/no-records-container';
import { DeviceInfo, NpvrState } from "modules/operational/npvr/redux/types";
import { useContext, useEffect, useState } from "react";

type DevicesProps = {
  npvr: NpvrState
  hhid: string
}

const TABLE_CONFIG: HeaderConfig = [
  {
    label: 'account.provisioned_devices.column_device_id',
    key: 'udid',
    sortable: true,
    defaultSort: true,
    sortedby: 'DESC'
  },
  {
    label: 'account.provisioned_devices.create_date.title',
    key: 'createDate',
    sortable: true,
  },
  {
    label: 'account.provisioned_devices.column_device_family',
    key: 'deviceFamily',
    sortable: true,
  },
  {
    label: 'account.provisioned_devices.column_last_managed',
    key: 'lastTechnicalDataEventDate',
    sortable: true,
  },
]

const PER_PAGE = 10

export default function Devices({ npvr, hhid }: DevicesProps) {
  const t = useContext(I18nContext)
  const [isToShowDevices, setIsToShowDevices] = useState(false)
  const [page, setPage] = useState(1)
  const [sort, setSort] = useState<SortObject<DeviceInfo>>({
    fieldKey: TABLE_CONFIG[0].key as keyof DeviceInfo,
    order: TABLE_CONFIG[0].sortedby,
  })
  const [list, setList] = useState(npvr.householdDevicesItems.devices)

  const handleDevicesOnClick = () => {
    setIsToShowDevices(!isToShowDevices)
  }

  const onSort = (sort: SortObject<DeviceInfo>) => {
    setSort(sort)
    setPage(1)
  
    const sortedDeviceList = sortLocalList(npvr.householdDevicesItems.devices, sort.fieldKey, sort.order)
    setList(sortedDeviceList)
  }

  useEffect(() => {
    setIsToShowDevices(false)
  }, [hhid])

  useEffect(() => {
    setPage(1)
  }, [npvr.householdDevicesItems])

  useEffect(() => {
    setList(sortLocalList(npvr.householdDevicesItems.devices, sort.fieldKey, sort.order))
  }, [npvr.householdDevicesItems.devices])

  const hasAssociatedDevices =
    npvr.householdDevicesItems && npvr.householdDevicesItems.devices && npvr.householdDevicesItems.devices.some((item: DeviceInfo) => item.udid.length !== 0);

  return (
    <div className="features-card">
      <Card className="card-is-relative">
        <Typography.Title style={{marginTop: "0.5rem"}} level={5}>{t('general.menu_devices')}</Typography.Title>
        <Button
          className="chevron-button"
          type={"primary"}
          shape={"circle"}  
          size={"small"}
          onClick={handleDevicesOnClick} 
          icon={<ChevronDown
              className={`icon has-padding-xs icon-white icon-svg icon-xx-small
              ${isToShowDevices ? 'icon-180' : ''}`}
          />}
        />
      <div className={`timeline-container-outer timeline-transition ${isToShowDevices ? 'timeline-expanded' : 'timeline-collapsed'}`}>
        {npvr.householdDevicesItems && hasAssociatedDevices ? (
          <div>
            <Table 
              items={getLocalPaginatedList(list, page, PER_PAGE)}
              header={TABLE_CONFIG}
              sort={sort}
              onSortCallback={onSort}>
            </Table>
            <div style={{marginTop: '1rem', marginBottom: '1rem'}}>
              {npvr.householdDevicesItems.devices.length > 10 && 
              <Pagination 
                page={page} 
                totalPages={getTotalPages(npvr.householdDevicesItems.devices.length, PER_PAGE)}
                setPage={setPage}>
              </Pagination>}
            </div>
          </div>
        ) : (
          <NoRecordsComponent />
        )}
      </div>
      </Card>
    </div>
  )
}
